import { createFileRoute } from "@tanstack/react-router";
import { ToolPage } from "@/components/dashboard/ToolPage";
import { MarginCalculator } from "@/components/tools/MarginCalculator";

export const Route = createFileRoute("/_authenticated/dashboard/margin")({
  head: () => ({
    meta: [
      { title: "Margin Estimator | XAU Pro Academy" },
      { name: "description", content: "XAUUSD margin, notional and risk versus margin for members." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: MarginPage,
});

function MarginPage() {
  return (
    <ToolPage eyebrow="Risk desk" title="Margin Estimator" intro="Required margin at any leverage, prefilled with live spot, set against the dollar loss at your stop."
      note="Leverage lowers the deposit, not the risk. Confirm your broker's contract specification before execution.">
      <MarginCalculator />
    </ToolPage>
  );
}
